import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=65251c9f&scoped=true&"
import script from "./MessageHeader.vue?vue&type=script&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessageHeader.scss?vue&type=style&index=0&id=65251c9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65251c9f",
  null
  
)

export default component.exports